import React from 'react';

import { Tab } from 'components/tabs';

import { StoreLocatorTabs } from './hooks';

interface IDeliveryTab {
  value: StoreLocatorTabs;
  label: string;
}

export const DeliveryTab: React.FC<IDeliveryTab> = ({ value, label, ...a11yProps }) => (
  <Tab label={label} {...a11yProps} value={value} />
);
